/**
 * Sort selector component
 */
export interface SortOption {
  value: string;
  label: string;
}

interface SortSelectorProps {
  options: SortOption[];
  value: string;
  direction: 'asc' | 'desc';
  onChange: (value: string) => void;
  onDirectionChange: (direction: 'asc' | 'desc') => void;
}

export function SortSelector({ options, value, direction, onChange, onDirectionChange }: SortSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-ink-muted">Sort by:</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="px-3 py-1.5 border border-hairline rounded-lg text-sm bg-surface text-ink-muted focus:ring-2 focus:ring-focus focus:border-transparent"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <button
        onClick={() => onDirectionChange(direction === 'asc' ? 'desc' : 'asc')}
        className="p-1.5 hover:bg-surface-2 rounded transition-colors"
        title={direction === 'asc' ? 'Sort descending' : 'Sort ascending'}
      >
        {direction === 'asc' ? (
          <svg className="w-5 h-5 text-ink-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
          </svg>
        ) : (
          <svg className="w-5 h-5 text-ink-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
          </svg>
        )}
      </button>
    </div>
  );
}
